import React from "react";
import "../../../svg.css";
import { connect } from "react-redux";
import { getDesc } from "../../../stores/actions/nomenclature";

const wordWrap = (str, maxWidth) => {

  var newLineStr = "\n";
  var done = false;
  var res = "";

  do {
    var found = false;
    for (var i = maxWidth - 1; i >= 0; i--) {
      if (testWhite(str.charAt(i))) {
        res = res + [str.slice(0, i), newLineStr].join("");
        str = str.slice(i + 1);
        found = true;
        break;
      }
    }
    if (!found) {
      res += [str.slice(0, maxWidth), newLineStr].join("");
      str = str.slice(maxWidth);
    }

    if (str.length < maxWidth) done = true;
  } while (!done);

  let wordwraped = res + str;
  return wordwraped.split("\n");
};

const testWhite = x => {
  var white = new RegExp(/^\s$/);
  return white.test(x.charAt(0));
};
const ExplainUCFeatures = props => {
  let wordwraped_desc = [];
  let box_height = 0;
  let options_package = "";
  let option_desc = <React.Fragment />;
  var modeldef = [
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" }
  ];
  if (
    typeof props.compare != "undefined" &&
    typeof props.compare.nomenclature != "undefined"
  ) {
  
    let type = props.type;
    // if (typeof type === "undefined") type = props.type;

    var nomenclature = props.compare.nomenclature.filter(item => {
      if (item.name === type) return item;
    });
    if (nomenclature.length > 0) nomenclature = nomenclature[0];

    
    if (
      typeof props.modelnumber != "undefined" &&
      props.modelnumber.length >= 12
    ) {
      var modelno = props.modelnumber;
      var BTU_add = "";
      var BTU_pos = 0;
      if(modelno.indexOf("_")>-1){
        BTU_pos = modelno[modelno.indexOf("_")+1];
        BTU_add = "_"+BTU_pos;
        modelno = modelno.replace(BTU_add,"");
      }
    

      modeldef[0] = {
        code: modelno[0],
        desc: getDesc(nomenclature.nomenclature[0].trans, modelno[0])
      };
      modeldef[1] = {
        code: modelno[1],
        desc: getDesc(nomenclature.nomenclature[1].trans, modelno[1])
      };
      modeldef[2] = {
        code: modelno[2],
        desc: getDesc(nomenclature.nomenclature[2].trans, modelno[2])
      };
      modeldef[3] = {
        code: modelno[3] + modelno[4] + modelno[5] + modelno[6],
        desc: getDesc(
          nomenclature.nomenclature[3].trans,
          modelno[3] + modelno[4] + modelno[5] + modelno[6] + BTU_add
        )
      };
      modeldef[4] = {
        code: modelno[7],
        desc: getDesc(nomenclature.nomenclature[4].trans, modelno[7])
      };
      modeldef[5] = {
        code: modelno[8],
        desc: getDesc(nomenclature.nomenclature[5].trans, modelno[8])
      };
      modeldef[6] = {
        code: modelno[9],
        desc: getDesc(nomenclature.nomenclature[6].trans, modelno[9])
      };
      modeldef[7] = {
        code: modelno[10],
        desc: getDesc(nomenclature.nomenclature[7].trans, modelno[10])
      };
      modeldef[8] = {
        code: modelno[11],
        desc: getDesc(nomenclature.nomenclature[8].trans, modelno[11])
      };
      modeldef[9] = {
        code: modelno[12],
        desc: getDesc(nomenclature.nomenclature[9].trans, modelno[12])
      };
      if (props.modelnumber.length >= 18) {
        modeldef[10] = {
          code:
            modelno[13] + modelno[14] + modelno[15] + modelno[16] + modelno[17],
          desc: getDesc(
            nomenclature.nomenclature[10].trans,
            modelno[13] + modelno[14] + modelno[15] + modelno[16] + modelno[17]
          )
        };
      } else {
        modeldef[10] = {
          code: "#####",
          desc: getDesc(nomenclature.nomenclature[10].trans, "#####")
        };
      }
    }
  }

   if (typeof modeldef[10].desc !== "string") {
        box_height = 100;
        option_desc = modeldef[10].desc;
      } else {
        wordwraped_desc = wordWrap(modeldef[10].desc, 39);
        box_height = wordwraped_desc.length * 20 + 20;
        if (box_height < 100) box_height = 100;
       
        option_desc = wordwraped_desc.map((text, index) => {
          return (
            <tspan key={text} x="0" y={index * 20}>
              {text}
            </tspan>
          );
        });
      }


  let brandbox = <rect className="cls-1" y="113" width="108" height="38" />;
  if (typeof modeldef[0].desc != "string") {
    brandbox = (
      <path
        className="cls-1"
        d="M0 113 L0 210 L190 210 L190 160 L105 160 L105 113 Z"
      />
    );
  }

  return (
    <React.Fragment>
      <p>
        <strong>Your New Model Number</strong>
      </p>
      <svg
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1000 290"
        style={{ width: "100%" }}
      >
        <rect
          id="Line_1"
          className="cls-5"
          x="30.75"
          y="61"
          width="3"
          height="65"
        />
        <rect
          id="Line_2"
          className="cls-5"
          x="111"
          y="61"
          width="3"
          height="68"
        />
        <rect
          id="Line_3"
          className="cls-5"
          x="111"
          y="104"
          width="3"
          height="150"
        />
        <rect
          id="Line_4"
          className="cls-5"
          x="180"
          y="61"
          width="3"
          height="68"
        />
        <rect
          id="Line_5"
          className="cls-5"
          x="290"
          y="61"
          width="3"
          height="130"
        />

        <rect
          id="Line_7"
          className="cls-5"
          x="363"
          y="61"
          width="3"
          height="68"
        />
        <rect
          id="Line_8"
          className="cls-5"
          x="435"
          y="61"
          width="3"
          height="68"
        />
        <rect
          id="Line_9"
          className="cls-5"
          x="435"
          y="112"
          width="3"
          height="130"
        />
        <rect
          id="Line_10"
          className="cls-5"
          x="506"
          y="61"
          width="3"
          height="68"
        />
        <rect
          id="Line_11"
          className="cls-5"
          x="566"
          y="61"
          width="3"
          height="68"
        />
        <rect
          id="Line_12"
          className="cls-5"
          x="566"
          y="112"
          width="3"
          height="68"
        />
        <rect
          id="Line_13"
          className="cls-5"
          x="650"
          y="61"
          width="3"
          height="68"
        />
        <rect
          id="Line_14"
          className="cls-5"
          x="720"
          y="61"
          width="3"
          height="200"
        />
        <rect
          id="Line_15"
          className="cls-5"
          x="800"
          y="61"
          width="3"
          height="130"
        />

        {brandbox}

        <rect
          id="Explain_bg_box1"
          className="cls-1"
          x="130"
          y="113"
          width="185"
          height="38"
        ></rect>
        <rect
          id="Explain_bg_box2"
          className="cls-1"
          x="320"
          y="113"
          width="110"
          height="38"
        />
        <rect
          id="Explain_bg_box3"
          className="cls-1"
          x="445"
          y="113"
          width="115"
          height="38"
        />
        <rect
          id="Explain_bg_box4"
          className="cls-1"
          x="575"
          y="113"
          width="270"
          height="38"
        />
        <rect
          id="Explain_bg_box5"
          className="cls-1"
          x="145"
          y="170"
          width="180"
          height="38"
        />
        <rect
          id="Explain_bg_box6"
          className="cls-1"
          x="90"
          y="224"
          width="180"
          height="38"
        />
        <rect
          id="Explain_bg_box7"
          className="cls-1"
          x="330"
          y="224"
          width="160"
          height="38"
        />
        <rect
          id="Explain_bg_box8"
          className="cls-1"
          x="505"
          y="170"
          width="176"
          height="38"
        />
        <rect
          id="Explain_bg_box9"
          className="cls-1"
          x="610"
          y="224"
          width="130"
          height="38"
        />
        <rect
          id="Explain_bg_box10"
          className="cls-1"
          x="750"
          y="170"
          width="250"
          height="100"
        />
        <rect
          id="blu_char_bg_1"
          className="cls-2"
          x="0"
          width="64"
          height="64"
          rx="12"
          ry="12"
        />
        <rect
          id="blu_char_bg_2"
          className="cls-2"
          x="70.67"
          width="64"
          height="64"
          rx="12"
          ry="12"
        />
        <rect
          id="blu_char_bg_3"
          className="cls-2"
          x="142"
          width="64"
          height="64"
          rx="12"
          ry="12"
        />
        <rect
          id="blu_char_bg_4"
          className="cls-2"
          x="333.25"
          width="64"
          height="64"
          rx="12"
          ry="12"
        />
        <rect
          id="blu_char_bg_5"
          className="cls-2"
          x="404.67"
          width="64"
          height="64"
          rx="12"
          ry="12"
        />
        <rect
          id="blu_char_bg_6"
          className="cls-2"
          x="476.25"
          width="64"
          height="64"
          rx="12"
          ry="12"
        />
        <rect
          id="blu_char_bg_7"
          className="cls-2"
          x="548"
          width="64"
          height="64"
          rx="12"
          ry="12"
        />
        <rect
          id="blu_char_bg_8"
          className="cls-2"
          x="619.5"
          width="64"
          height="64"
          rx="12"
          ry="12"
        />
        <rect
          id="blu_char_bg_9"
          className="cls-2"
          x="213"
          width="115"
          height="64"
          rx="12"
          ry="12"
        />
        <rect
          id="blu_char_bg_10"
          className="cls-2"
          x="690.67"
          width="64"
          height="64"
          rx="12"
          ry="12"
        />
        <rect
          id="blu_char_bg_10"
          className="cls-2"
          x="760.67"
          width="150"
          height="64"
          rx="12"
          ry="12"
        />
        <text id="desc_1" className="cls-3" transform="translate(2 135)">
          {modeldef[0].desc}
        </text>
        <text id="desc_2" className="cls-3" transform="translate(100 250)">
          {modeldef[1].desc}
        </text>
        <text id="desc_3" className="cls-3" transform="translate(135 136.23)">
          {modeldef[2].desc}
        </text>
        <text id="desc_4" className="cls-3" transform="translate(160 195)">
          {(props.replace_btu)?props.formatNumberValue(props.replace_btu):props.formatNumberValue(modeldef[3].desc)}
        </text>
        <text id="desc_5" className="cls-3" transform="translate(330 136.23)">
          {modeldef[4].desc}
        </text>
        <text id="desc_6" className="cls-3" transform="translate(337 250)">
          {modeldef[5].desc}
        </text>
        <text
          id="desc_7"
          className="cls-3"
          transform="translate(464.49 136.23)"
        >
          {modeldef[6].desc}
        </text>
        <text
          id="desc_8"
          className="cls-3"
          transform="translate(514.49 193.23)"
        >
          {modeldef[7].desc}
        </text>
        <text id="desc_9" className="cls-3" transform="translate(580  136.23)">
          {modeldef[8].desc}
        </text>

        <text id="desc_10" className="cls-3" transform="translate(620 250)">
          {modeldef[9].desc}
        </text>
        <text id="desc_11" className="cls-3" transform="translate(760 190)">
          {option_desc}
        </text>

        <text
          id="code_1"
          className="cls-4"
          transform={
            modeldef[0].code === "M"
              ? "translate(8 45)"
              : "translate(15.58 48.7)"
          }
        >
          {modeldef[0].code === "M" ? "⍦" : modeldef[0].code}
        </text>
        <text id="code_2" className="cls-4" transform="translate(85.58 48.7)">
          {modeldef[1].code}
        </text>
        <text id="code_3" className="cls-4" transform="translate(153 48.7)">
          {modeldef[2].code}
        </text>
        <text id="code_4" className="cls-4" transform="translate(215 48.7)">
          {modeldef[3].code}
        </text>
        <text id="code_5" className="cls-4" transform="translate(348.58 48.7)">
          {modeldef[4].code}
        </text>
        <text id="code_6" className="cls-4" transform="translate(419.58 48.7)">
          {modeldef[5].code}
        </text>
        <text id="code_7" className="cls-4" transform="translate(492.58 48.7)">
          {modeldef[6].code}
        </text>
        <text id="code_8" className="cls-4" transform="translate(562.58 48.7)">
          {modeldef[7].code}
        </text>
        <text id="code_9" className="cls-4" transform="translate(634.58 48.7)">
          {modeldef[8].code}
        </text>
        <text id="code_10" className="cls-4" transform="translate(705.17 48.7)">
          {modeldef[9].code}
        </text>
        <text id="code_11" className="cls-4" transform="translate(765 48.7)">
          {modeldef[10].code}
        </text>
      </svg>
    </React.Fragment>
  );
};

function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps)(ExplainUCFeatures);
